import { ReactNode } from "react";
import ShebaFintechPhoneIcon from "../assets/icons/ShebaFintechPhoneIcon";
import ShebaFintechLogo from "../assets/images/shebaFintechLogo.png";

type ShebaFintechLayoutProps = {
  children: ReactNode;
};

export default function ShebaFintechLayout({
  children,
}: ShebaFintechLayoutProps) {
  return (
    <>
      <div className="bg-cyan-50 h-screen flex items-center justify-center">
        <div className="w-[30%]">
          <div className="self-stretch h-2 bg-cyan-500" />

          <div className="flex items-center justify-center bg-white">
            <img
              className="w-45 h-20"
              src={ShebaFintechLogo}
              alt="Sheba Fintech Logo"
            />
          </div>

          <div className="self-stretch bg-cyan-500 p-12 pb-0">
            <div>{children}</div>

            <div className="flex justify-center items-center h-full mt-12 pb-2">
              <ShebaFintechPhoneIcon />
              <div className="justify-start text-white text-base font-medium font-['Inter'] uppercase leading-7 ml-2 mb-1">
                123456
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
